module.exports = __webpack_public_path__ + "static/media/graph_embeddings.fed0850a.png";